import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { useTranslation } from "react-i18next";
import writeXlsxFile from 'write-excel-file'

import './css/showQuestion.css'
import Popups from '../../components/Popups'
import Question from './components/question'
import { TbBorderRadius } from 'react-icons/tb'
import { GET, dateToText, ClassToName, SecoundsToTime} from '../../inc/Fetch';

export default function TaskStatsDownload({ data, setOpen }) {

    const { t } = useTranslation();
    const params = useParams();
    const navigate = useNavigate();

    async function loadData() {
        let r = await GET(`task/viewMyTask?_id=${params?.id}`);
        if (!r?.task?._id) {
            return false;
        }


        /*
        [t("class")]: ClassToName({ classes: r?.task?.classes, string: true}),
        //             [t("name")]: v?.name,
        //             [t("login_username")]: v?.user,
        //             [t("tasks_send_show_date")]: v?.answer?.date ? dateToText(v?.answer?.date, "datetime") : "--",
        //             [t("tasks_send_timer")]: v?.answer?.timer || "--",
        //             [t("tasks_score")]: v?.answer?.score || 0 + "%",
        */

        const HEADER_ROW = [
            {
                value: t("class"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30,
            },
            {
                value: t("student"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30
            },
            {
                value: t("login_username"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30
            },
            {
                value: t("tasks_send_show_date"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30
            },
            {
                value: t("tasks_send_timer"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30
            },
            {
                value: t("tasks_score"),
                fontWeight: 'bold',
                align: "center",
                alignVertical:"center",
                height:30
            }
        ]

        const columns = [
            { width: 15 },
            { width: 25 },
            { width: 15 },
            { width: 20 },
            { width: 12 },
            { width: 12 },
        ]

        const DATA_ROW_1 = [];
        r?.students?.map(v => {

            
            DATA_ROW_1.push([
                {
                    type: String,
                    value: ClassToName({ classes: r?.task?.classes, string: true}),
                    align: "center",
                    alignVertical:"center",
                    height:30
                },
                {
                    type: String,
                    value: v?.name,
                    align: "center",
                    alignVertical:"center",
                    height:30
                },
                {
                    type: String,
                    value: v?.user,
                    align: "center",
                    alignVertical:"center",
                    height:30
                },
                {
                    value: v?.answer?.date ? dateToText(v?.answer?.date, "datetime") : "--",
                    align: "center",
                    alignVertical:"center",
                    height:30
                },
                {
                    type: String,
                    value: v?.answer?.timer ? SecoundsToTime({ time: v?.answer?.timer }) : "--",
                    align: "center",
                    alignVertical:"center",
                    height:30
                },
                {
                    type: String,
                    value: v?.answer?.score ? `${v?.answer?.score}%` : '--',
                    align: "center",
                    alignVertical:"center",
                    height:30
                }
            ]);
        });
        

        const data = [HEADER_ROW, ...DATA_ROW_1];
          
        await writeXlsxFile(data, {
            columns,
            fileName: 'file.xlsx',
            fontSize: 12,
            height:30,
            rightToLeft: true
        });

        setTimeout(() => {
            close();
        }, 300);

        
    }

    useEffect(() => {

        loadData();

    }, []);
    
    return (
        <div>

        </div>
    )
}
